<template>
    <div class="wrapper-div">
        <div
            class="local-profile-dialog extend-bottom"
            :style="{ 'max-width': width + 'px' }"
        >
            <div
                style="position: relative; top: 42px; left: 20px; width: calc(100% - 40px)"
            >
                <IconBtn
                    v-if="hasHistory"
                    @click="stepBackHistory"
                    class="primary-outlined closeBtnWrapper"
                    name="arrow-left"
                    size="lg"
                    style="float: left"
                />
                <IconBtn
                    class="primary-outlined closeBtnWrapper"
                    @click="closeDialog"
                    name="times"
                    size="lg"
                    style="float: right;"
                />
            </div>
            <img v-if="poster" class="poster-img" ref="image" :src="poster" />
            <img
                v-else
                class="poster-img"
                ref="image"
                src="https://highered.global/wp-content/uploads/2020/01/default-company-banner.jpg"
            />
            <Paper
                style="width: 100%;"
                class="internal-layout"
                :class="{
                    'overlay-poster-img': poster,
                }"
            >
                <Paper :header="payload.title" restrictHeaderWidth>
                    <div
                        :style="{
                            'max-height': height ? height + 'px' : 'none',
                            height: height ? height + 'px' : 'none',
                        }"
                        class="article-layout d-flex flex-column"
                    >
                        <div
                            v-if="!articles"
                            class="p-5 flex-grow"
                            style="padding-bottom: 20px"
                        >
                            <Spinner
                                class="primary-color"
                                style="display: block; margin: 40px auto;"
                            />
                        </div>
                        <div
                            v-else
                            class="p-5 flex-grow"
                            v-html="description"
                        />
                        <Paper
                            :header="$t('companyDetail.videos.header')"
                            v-if="videos && videos.length > 0"
                        >
                            <div v-if="!videos" style="padding-bottom: 20px">
                                <Spinner
                                    class="primary-color"
                                    style="display: block; margin: 40px auto;"
                                />
                            </div>
                            <Carousel
                                v-else
                                :items="videos"
                                :component="getVideoComponent()"
                                hideArrows
                                :noResourcesMessage="
                                    $t('companyDetail.videos.noVideos')
                                "
                            />
                        </Paper>
                        <Paper
                            :header="$t('companyDetail.articles.header')"
                            v-if="articles && articles.length > 0"
                        >
                            <div v-if="!articles" style="padding-bottom: 20px">
                                <Spinner
                                    class="primary-color"
                                    style="display: block; margin: 40px auto;"
                                />
                            </div>
                            <Carousel
                                v-else
                                :items="articles"
                                hideArrows
                                :noResourcesMessage="
                                    $t('companyDetail.articles.noArticles')
                                "
                            />
                        </Paper>
                    </div>
                </Paper>

                <JobModule
                    :label="t$t('companyDetail.jobModule.header')"
                    :companyId="payload.id"
                    :companyName="payload.title"
                    @click="closeDialog"
                    smallView
                    :restrictHeight="height"
                    redirectUsingCompanyName
                />
            </Paper>
        </div>
    </div>
</template>

<script>
import JobModule from './JobModule';
import DialogService from '~/services/DialogService';
import VideoCarouselItem from '~/components/miscellaneous/Videos.CarouselItem';

import Spinner from '~/components/builders/Spinner';

import * as Mappers from '~/utils/mappers/mediaMappers';

export default {
    name: 'LocalProfile.Dialog',

    components: {
        JobModule,
        Spinner,
    },

    data() {
        return {
            height: 600,
            width: 600,
        };
    },

    computed: {
        poster() {
            return this.orgProfile.data.banner;
        },
        hasHistory() {
            return this.$interfaces.dialogModal.hasHistory();
        },
        payload() {
            return this.$interfaces.dialogModal.getState().payload;
        },
        orgProfile() {
            return this.$interfaces.organization.profile
                .id(this.payload.id)
                .get({ reactive: true });
        },
        videos() {
            if (this.orgProfile.loading) return;
            return Mappers.mapVideos(this.orgProfile.data.videos);
        },
        articles() {
            if (this.orgProfile.loading) return;
            return Mappers.mapArticles(this.orgProfile.data.articles);
        },
        description() {
            if (this.orgProfile.loading) return;
            return this.orgProfile.data.description;
        },
    },

    methods: {
        getVideoComponent() {
            return VideoCarouselItem;
        },

        closeDialog() {
            this.$interfaces.dialogModal.getState().resolver.res();
        },

        handleResizeEvent() {
            this.width = window.innerWidth;
            this.height =
                this.width < 600
                    ? null
                    : window.innerHeight * 0.9 - this.$refs.image.clientHeight;
        },

        stepBackHistory() {
            this.$interfaces.dialogModal.popState();
        },
    },

    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.handleResizeEvent);
        });
        this.handleResizeEvent();
    },

    destroyed() {
        window.removeEventListener('resize', this.handleResizeEvent);
    },
};
</script>

<style lang="css" scoped>

.local-profile-dialog {
    margin: 0 auto;
    max-width: var(--grid-width);
    width: var(--grid-width);
}

.internal-layout {
    display: grid;
    grid-template-columns: 3fr 1fr;
}

.poster-img {
    z-index: -5;
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    border-top-left-radius: var(--border-radius);
    border-top-right-radius: var(--border-radius);

    background-color: rgb(230, 230, 230);
}

.overlay-poster-img {
    position: relative;
    top: calc(-1*var(--border-radius));
}

.closeBtnWrapper {
    color: var(--primary);
}

.article-layout {
    overflow-y: scroll;
}

.wrapper-div {
    width: 100%;
    height: 100%;
}

@media only screen and (max-width: 600px) {
    .internal-layout {
        grid-template-columns: 1fr;
        grid-auto-flow: row;
        overflow: scroll;
    }

    .article-layout {
        overflow: hidden;
    }

    .wrapper-div {
        overflow-y: scroll;
        overflow-x: hidden;
    }
}
</style>
